import { LEVELUP_SIDEPANEL_ACTIONS } from './actions';

export default function levelUpSidePanelContextReducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case LEVELUP_SIDEPANEL_ACTIONS.OPEN_SIDEPANEL: {
      let detailsObj;
      if (payload.levelUpCompetencyId) {
        detailsObj = {
          competencyId: null,
          levelUpId: null,
          levelUpCompetencyId: payload.levelUpCompetencyId,
        };
      } else {
        detailsObj = {
          competencyId: payload.competencyId,
          levelUpId: payload.levelUpId,
          levelUpCompetencyId: null,
        };
      }

      return {
        ...state,
        isOpen: true,
        reporteeId: payload.reporteeId,
        isLoggedInEmployeeManager: payload.isLoggedInEmployeeManager,
        checkInInstanceId: payload.checkInInstanceId,
        checkInParentId: payload.checkInParentId,
        filterEmpIds: payload.filterEmpIds,
        showActionItems: payload.showActionItems,
        ...detailsObj,
      };
    }

    case LEVELUP_SIDEPANEL_ACTIONS.CLOSE_SIDEPANEL: {
      return {
        ...state,
        isOpen: false,
        reporteeId: null,
        competencyId: null,
        levelUpId: null,
        levelUpCompetencyId: null,
        isLoggedInEmployeeManager: false,
        levelUpCompetencyDetails: {},
        checkInInstanceId: null,
        checkInParentId: null,
        filterEmpIds: [],
        closedCount: state.closedCount + 1,
      };
    }

    case LEVELUP_SIDEPANEL_ACTIONS.SET_LEVEL_UP_TARGET_DATES: {
      return {
        ...state,
        levelUpTargetDates: payload,
      };
    }

    case LEVELUP_SIDEPANEL_ACTIONS.SET_LEVEL_UP_PROGRESS_STATUSES: {
      return {
        ...state,
        levelUpProgressStatuses: payload,
      };
    }

    case LEVELUP_SIDEPANEL_ACTIONS.SET_LEVEL_UP_COMPETENCY_DETAILS: {
      return {
        ...state,
        levelUpCompetencyDetails: payload,
      };
    }

    case LEVELUP_SIDEPANEL_ACTIONS.UPDATE_COMPETENCY_TARGET_DATE: {
      return {
        ...state,
        levelUpCompetencyDetails: {
          ...state.levelUpCompetencyDetails,
          targetDate: payload,
        },
      };
    }

    case LEVELUP_SIDEPANEL_ACTIONS.UPDATE_COMPETENCY_PROGRESS_STATUS: {
      return {
        ...state,
        levelUpCompetencyDetails: {
          ...state.levelUpCompetencyDetails,
          progress: payload,
        },
      };
    }

    default:
      return state;
  }
}
